module.exports = __webpack_public_path__ + "images/footer_fukidashi_sp_3d110aaef87e0828569a11d7cf445f55.png";